import {grayColors} from "../../architecture/gray-colors";

export const baseColors = {
    base01: "#015536",
    base01Contrast: "#262627",
    base01Dark: "#05372C",
    base01Light: "#41B169",

    base02: "#047C4C",
    base02Contrast: "",
    base02Dark: "",
    base02Light: "",

    base03: "#EBEDEF",
    base03Contrast: "",
    base03Dark: "",
    base03Light: "",

    base04: "linear-gradient(90deg, #F1C141 0%, #F9F19A 48.96%, #F1C141 100%)",
    base05: "#F12727",
    gold: "#F1C141",
    yellow: "#F9F19A",
    ...grayColors
}
